import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip"
import InfoIcon from "@/assets/icons/information-circle.svg";

export interface TooltipInfoProps {
    title?: string;
    text?: string;
    triggerContent?: React.ReactNode;
    contentClassName?: string;
}

export const TooltipInfo = ({ title, text, triggerContent, contentClassName }: TooltipInfoProps) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="cursor-pointer">
                        {!triggerContent && <InfoIcon className="w-4 h-4" />}
                        {triggerContent}
                    </span>
                </TooltipTrigger>
                <TooltipContent className="p-0">
                    <div className={`w-60 p-3.5 bg-white rounded border border-black flex-col justify-start items-start gap-2.5 inline-flex ${contentClassName || ''}`}>
                        <div className="flex-col justify-start items-start gap-1.5 flex">
                            <div className="text-black text-sm font-semibold">{title}</div>
                            <div className="text-black text-xs font-normal">{text}</div>
                        </div>
                    </div>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
